import { Pipe, ChangeDetectorRef, EventEmitter, NgZone, InjectionToken, Inject, Optional, NgModule } from '@angular/core';
import * as moment from 'moment';
import { duration, relativeTimeThreshold, unix, utc, parseZone, isMoment, isDate, locale } from 'moment';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */
/** @type {?} */
import * as ɵngcc0 from '@angular/core';
const momentConstructor = moment;
class AddPipe {
    /**
     * @param {?} value
     * @param {?} amount
     * @param {?=} unit
     * @return {?}
     */
    transform(value, amount, unit) {
        if (typeof amount === 'undefined' || (typeof amount === 'number' && typeof unit === 'undefined')) {
            throw new Error('AddPipe: missing required arguments');
        }
        return momentConstructor(value).add(amount, unit);
    }
}
AddPipe.ngPipeDef = ɵngcc0.ɵɵdefinePipe({ name: "amAdd", type: AddPipe, factory: function AddPipe_Factory(t) { return new (t || AddPipe)(); }, pure: true });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(AddPipe, [{
        type: Pipe,
        args: [{ name: 'amAdd' }]
    }], null, { transform: [] });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */
/** @type {?} */
const momentConstructor$1 = moment;
class CalendarPipe {
    /**
     * @param {?} cdRef
     * @param {?} ngZone
     */
    constructor(cdRef, ngZone) {
        this.cdRef = cdRef;
        this.ngZone = ngZone;
        // using a single static timer for all instances of this pipe for performance reasons
        CalendarPipe.initTimer(ngZone);
        CalendarPipe.refs++;
        // values such as Today will need to be replaced with Yesterday after midnight,
        // so make sure we subscribe to an EventEmitter that we set up to emit at midnight
        this.midnightSub = CalendarPipe.midnight.subscribe(() => {
            this.ngZone.run(() => this.cdRef.markForCheck());
        });
    }
    /**
     * @param {?} value
     * @param {...?} args
     * @return {?}
     */
    transform(value, ...args) {
        /** @type {?} */
        let formats = null;
        /** @type {?} */
        let referenceTime = null;
        for (let i = 0, len = args.length; i < len; i++) {
            if (args[i] !== null) {
                if (typeof args[i] === 'object' && !isMoment(args[i])) {
                    formats = args[i];
                }
                else {
                    referenceTime = momentConstructor$1(args[i]);
                }
            }
        }
        return momentConstructor$1(value).calendar(referenceTime, formats);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (CalendarPipe.refs > 0) {
            CalendarPipe.refs--;
        }
        if (CalendarPipe.refs === 0) {
            CalendarPipe.removeTimer();
        }
        this.midnightSub.unsubscribe();
    }
    /**
     * @param {?} ngZone
     * @return {?}
     */
    static initTimer(ngZone) {
        // initialize the timer
        if (!CalendarPipe.midnight) {
            CalendarPipe.midnight = new EventEmitter();
            if (typeof window !== 'undefined') {
                /** @type {?} */
                const timeToUpdate = CalendarPipe._getMillisecondsUntilUpdate();
                CalendarPipe.timer = ngZone.runOutsideAngular(() => {
                    return window.setTimeout(() => {
                        // emit the current date
                        CalendarPipe.midnight.emit(new Date());
                        // refresh the timer
                        CalendarPipe.removeTimer();
                        CalendarPipe.initTimer(ngZone);
                    }, timeToUpdate);
                });
            }
        }
    }
    /**
     * @return {?}
     */
    static removeTimer() {
        if (CalendarPipe.timer) {
            window.clearTimeout(CalendarPipe.timer);
            CalendarPipe.timer = null;
            CalendarPipe.midnight = null;
        }
    }
    /**
     * @return {?}
     */
    static _getMillisecondsUntilUpdate() {
        /** @type {?} */
        const now = momentConstructor$1();
        /** @type {?} */
        const tomorrow = momentConstructor$1().startOf('day').add(1, 'days');
        /** @type {?} */
        const timeToMidnight = tomorrow.valueOf() - now.valueOf();
        return timeToMidnight + 1000; // 1 second after midnight
    }
}
CalendarPipe.ngPipeDef = ɵngcc0.ɵɵdefinePipe({ name: "amCalendar", type: CalendarPipe, factory: function CalendarPipe_Factory(t) { return new (t || CalendarPipe)(ɵngcc0.ɵɵdirectiveInject(ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(NgZone)); }, pure: false });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(CalendarPipe, [{
        type: Pipe,
        args: [{ name: 'amCalendar', pure: false }]
    }], function () { return [{ type: ChangeDetectorRef }, { type: NgZone }]; }, { constructor: [], cdRef: [], ngZone: [], midnightSub: [], transform: [], ngOnDestroy: [] });
/**
 * Internal reference counter, so we can clean up when no instances are in use
 */
CalendarPipe.refs = 0;
CalendarPipe.timer = null;
CalendarPipe.midnight = null;
/** @nocollapse */
CalendarPipe.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: NgZone }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */
/** @type {?} */
const momentConstructor$2 = moment;
class DateFormatPipe {
    /**
     * @param {?} value
     * @param {...?} args
     * @return {?}
     */
    transform(value, ...args) {
        if (!value) {
            return '';
        }
        return momentConstructor$2(value).format(args[0]);
    }
}
DateFormatPipe.ngPipeDef = ɵngcc0.ɵɵdefinePipe({ name: "amDateFormat", type: DateFormatPipe, factory: function DateFormatPipe_Factory(t) { return new (t || DateFormatPipe)(); }, pure: true });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(DateFormatPipe, [{
        type: Pipe,
        args: [{ name: 'amDateFormat' }]
    }], null, { transform: [] });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */
/** @type {?} */
const momentConstructor$3 = moment;
class DifferencePipe {
    /**
     * @param {?} value
     * @param {?} otherValue
     * @param {?=} unit
     * @param {?=} precision
     * @return {?}
     */
    transform(value, otherValue, unit, precision) {
        /** @type {?} */
        const date = momentConstructor$3(value);
        /** @type {?} */
        const date2 = (otherValue !== null) ? momentConstructor$3(otherValue) : momentConstructor$3();
        return date.diff(date2, unit, precision);
    }
}
DifferencePipe.ngPipeDef = ɵngcc0.ɵɵdefinePipe({ name: "amDifference", type: DifferencePipe, factory: function DifferencePipe_Factory(t) { return new (t || DifferencePipe)(); }, pure: true });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(DifferencePipe, [{
        type: Pipe,
        args: [{ name: 'amDifference' }]
    }], null, { transform: [] });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */
/** @type {?} */
const NGX_MOMENT_OPTIONS = new InjectionToken('NGX_MOMENT_OPTIONS');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */
class DurationPipe {
    /**
     * @param {?=} momentOptions
     */
    constructor(momentOptions) {
        this.allowedUnits = ['ss', 's', 'm', 'h', 'd', 'M'];
        this._applyOptions(momentOptions);
    }
    /**
     * @param {?} value
     * @param {...?} args
     * @return {?}
     */
    transform(value, ...args) {
        if (typeof args === 'undefined' || args.length !== 1) {
            throw new Error('DurationPipe: missing required time unit argument');
        }
        return duration(value, (/** @type {?} */ (args[0]))).humanize();
    }
    /**
     * @param {?} momentOptions
     * @return {?}
     */
    _applyOptions(momentOptions) {
        if (!momentOptions) {
            return;
        }
        if (!!momentOptions.relativeTimeThresholdOptions) {
            /** @type {?} */
            const units = Object.keys(momentOptions.relativeTimeThresholdOptions);
            /** @type {?} */
            const filteredUnits = units.filter(unit => this.allowedUnits.indexOf(unit) !== -1);
            filteredUnits.forEach(unit => {
                relativeTimeThreshold(unit, momentOptions.relativeTimeThresholdOptions[unit]);
            });
        }
    }
}
DurationPipe.ngPipeDef = ɵngcc0.ɵɵdefinePipe({ name: "amDuration", type: DurationPipe, factory: function DurationPipe_Factory(t) { return new (t || DurationPipe)(ɵngcc0.ɵɵdirectiveInject(NGX_MOMENT_OPTIONS, 8)); }, pure: true });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(DurationPipe, [{
        type: Pipe,
        args: [{ name: 'amDuration' }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [NGX_MOMENT_OPTIONS]
            }] }]; }, { constructor: [], allowedUnits: [], transform: [], _applyOptions: [] });
/** @nocollapse */
DurationPipe.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [NGX_MOMENT_OPTIONS,] }] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */
class FromUnixPipe {
    /**
     * @param {?} value
     * @param {...?} args
     * @return {?}
     */
    transform(value, ...args) {
        if (typeof value === 'string') {
            value = +value;
        }
        return unix(value);
    }
}
FromUnixPipe.ngPipeDef = ɵngcc0.ɵɵdefinePipe({ name: "amFromUnix", type: FromUnixPipe, factory: function FromUnixPipe_Factory(t) { return new (t || FromUnixPipe)(); }, pure: true });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(FromUnixPipe, [{
        type: Pipe,
        args: [{ name: 'amFromUnix' }]
    }], null, { transform: [] });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */
/** @type {?} */
const momentConstructor$4 = moment;
class ParsePipe {
    /**
     * @param {?} value
     * @param {?} formats
     * @return {?}
     */
    transform(value, formats) {
        return momentConstructor$4(value, formats);
    }
}
ParsePipe.ngPipeDef = ɵngcc0.ɵɵdefinePipe({ name: "amParse", type: ParsePipe, factory: function ParsePipe_Factory(t) { return new (t || ParsePipe)(); }, pure: true });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(ParsePipe, [{
        type: Pipe,
        args: [{ name: 'amParse' }]
    }], null, { transform: [] });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */
class FromUtcPipe {
    /**
     * @param {?} value
     * @param {?=} formats
     * @param {...?} args
     * @return {?}
     */
    transform(value, formats, ...args) {
        return formats ? utc(value, formats) : utc(value);
    }
}
FromUtcPipe.ngPipeDef = ɵngcc0.ɵɵdefinePipe({ name: "amFromUtc", type: FromUtcPipe, factory: function FromUtcPipe_Factory(t) { return new (t || FromUtcPipe)(); }, pure: true });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(FromUtcPipe, [{
        type: Pipe,
        args: [{ name: 'amFromUtc' }]
    }], null, { transform: [] });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */
/** @type {?} */
const momentConstructor$5 = moment;
class IsAfterPipe {
    /**
     * @param {?} value
     * @param {?} otherValue
     * @param {?=} unit
     * @return {?}
     */
    transform(value, otherValue, unit) {
        return momentConstructor$5(value).isAfter(momentConstructor$5(otherValue), unit);
    }
}
IsAfterPipe.ngPipeDef = ɵngcc0.ɵɵdefinePipe({ name: "amIsAfter", type: IsAfterPipe, factory: function IsAfterPipe_Factory(t) { return new (t || IsAfterPipe)(); }, pure: true });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(IsAfterPipe, [{
        type: Pipe,
        args: [{
                name: 'amIsAfter'
            }]
    }], null, { transform: [] });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */
/** @type {?} */
const momentConstructor$6 = moment;
class IsBeforePipe {
    /**
     * @param {?} value
     * @param {?} otherValue
     * @param {?=} unit
     * @return {?}
     */
    transform(value, otherValue, unit) {
        return momentConstructor$6(value).isBefore(momentConstructor$6(otherValue), unit);
    }
}
IsBeforePipe.ngPipeDef = ɵngcc0.ɵɵdefinePipe({ name: "amIsBefore", type: IsBeforePipe, factory: function IsBeforePipe_Factory(t) { return new (t || IsBeforePipe)(); }, pure: true });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(IsBeforePipe, [{
        type: Pipe,
        args: [{
                name: 'amIsBefore'
            }]
    }], null, { transform: [] });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */
/** @type {?} */
const momentConstructor$7 = moment;
class LocalTimePipe {
    /**
     * @param {?} value
     * @return {?}
     */
    transform(value) {
        return momentConstructor$7(value).local();
    }
}
LocalTimePipe.ngPipeDef = ɵngcc0.ɵɵdefinePipe({ name: "amLocal", type: LocalTimePipe, factory: function LocalTimePipe_Factory(t) { return new (t || LocalTimePipe)(); }, pure: true });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(LocalTimePipe, [{
        type: Pipe,
        args: [{ name: 'amLocal' }]
    }], null, { transform: [] });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */
// under systemjs, moment is actually exported as the default export, so we account for that
/** @type {?} */
const momentConstructor$8 = moment;
class LocalePipe {
    /**
     * @param {?} value
     * @param {?} locale
     * @return {?}
     */
    transform(value, locale$$1) {
        return momentConstructor$8(value).locale(locale$$1);
    }
}
LocalePipe.ngPipeDef = ɵngcc0.ɵɵdefinePipe({ name: "amLocale", type: LocalePipe, factory: function LocalePipe_Factory(t) { return new (t || LocalePipe)(); }, pure: true });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(LocalePipe, [{
        type: Pipe,
        args: [{ name: 'amLocale' }]
    }], null, { transform: [] });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */
class ParseZonePipe {
    /**
     * @param {?} value
     * @return {?}
     */
    transform(value) {
        return parseZone(value);
    }
}
ParseZonePipe.ngPipeDef = ɵngcc0.ɵɵdefinePipe({ name: "amParseZone", type: ParseZonePipe, factory: function ParseZonePipe_Factory(t) { return new (t || ParseZonePipe)(); }, pure: true });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(ParseZonePipe, [{
        type: Pipe,
        args: [{ name: 'amParseZone' }]
    }], null, { transform: [] });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */
/** @type {?} */
const momentConstructor$9 = moment;
class SubtractPipe {
    /**
     * @param {?} value
     * @param {?} amount
     * @param {?=} unit
     * @return {?}
     */
    transform(value, amount, unit) {
        if (typeof amount === 'undefined' || (typeof amount === 'number' && typeof unit === 'undefined')) {
            throw new Error('SubtractPipe: missing required arguments');
        }
        return momentConstructor$9(value).subtract(amount, unit);
    }
}
SubtractPipe.ngPipeDef = ɵngcc0.ɵɵdefinePipe({ name: "amSubtract", type: SubtractPipe, factory: function SubtractPipe_Factory(t) { return new (t || SubtractPipe)(); }, pure: true });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(SubtractPipe, [{
        type: Pipe,
        args: [{ name: 'amSubtract' }]
    }], null, { transform: [] });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */
/** @type {?} */
const momentConstructor$a = moment;
class TimeAgoPipe {
    /**
     * @param {?} cdRef
     * @param {?} ngZone
     */
    constructor(cdRef, ngZone) {
        this.cdRef = cdRef;
        this.ngZone = ngZone;
    }
    /**
     * @param {?} m
     * @return {?}
     */
    format(m) {
        return m.from(momentConstructor$a(), this.lastOmitSuffix);
    }
    /**
     * @param {?} value
     * @param {?=} omitSuffix
     * @param {?=} formatFn
     * @return {?}
     */
    transform(value, omitSuffix, formatFn) {
        if (this.hasChanged(value, omitSuffix)) {
            this.lastTime = this.getTime(value);
            this.lastValue = value;
            this.lastOmitSuffix = omitSuffix;
            this.lastLocale = this.getLocale(value);
            this.formatFn = formatFn || this.format.bind(this);
            this.removeTimer();
            this.createTimer();
            this.lastText = this.formatFn(momentConstructor$a(value));
        }
        else {
            this.createTimer();
        }
        return this.lastText;
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.removeTimer();
    }
    /**
     * @return {?}
     */
    createTimer() {
        if (this.currentTimer) {
            return;
        }
        /** @type {?} */
        const momentInstance = momentConstructor$a(this.lastValue);
        /** @type {?} */
        const timeToUpdate = this.getSecondsUntilUpdate(momentInstance) * 1000;
        this.currentTimer = this.ngZone.runOutsideAngular(() => {
            if (typeof window !== 'undefined') {
                return window.setTimeout(() => {
                    this.lastText = this.formatFn(momentConstructor$a(this.lastValue));
                    this.currentTimer = null;
                    this.ngZone.run(() => this.cdRef.markForCheck());
                }, timeToUpdate);
            }
            else {
                return null;
            }
        });
    }
    /**
     * @return {?}
     */
    removeTimer() {
        if (this.currentTimer) {
            window.clearTimeout(this.currentTimer);
            this.currentTimer = null;
        }
    }
    /**
     * @param {?} momentInstance
     * @return {?}
     */
    getSecondsUntilUpdate(momentInstance) {
        /** @type {?} */
        const howOld = Math.abs(momentConstructor$a().diff(momentInstance, 'minute'));
        if (howOld < 1) {
            return 1;
        }
        else if (howOld < 60) {
            return 30;
        }
        else if (howOld < 180) {
            return 300;
        }
        else {
            return 3600;
        }
    }
    /**
     * @param {?} value
     * @param {?=} omitSuffix
     * @return {?}
     */
    hasChanged(value, omitSuffix) {
        return this.getTime(value) !== this.lastTime
            || this.getLocale(value) !== this.lastLocale
            || omitSuffix !== this.lastOmitSuffix;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    getTime(value) {
        if (isDate(value)) {
            return value.getTime();
        }
        else if (isMoment(value)) {
            return value.valueOf();
        }
        else {
            return momentConstructor$a(value).valueOf();
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    getLocale(value) {
        return isMoment(value) ? value.locale() : locale();
    }
}
TimeAgoPipe.ngPipeDef = ɵngcc0.ɵɵdefinePipe({ name: "amTimeAgo", type: TimeAgoPipe, factory: function TimeAgoPipe_Factory(t) { return new (t || TimeAgoPipe)(ɵngcc0.ɵɵdirectiveInject(ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(NgZone)); }, pure: false });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(TimeAgoPipe, [{
        type: Pipe,
        args: [{ name: 'amTimeAgo', pure: false }]
    }], function () { return [{ type: ChangeDetectorRef }, { type: NgZone }]; }, { constructor: [], cdRef: [], ngZone: [], format: [], transform: [], lastTime: [], lastValue: [], lastOmitSuffix: [], lastLocale: [], formatFn: [], lastText: [], ngOnDestroy: [], createTimer: [], currentTimer: [], removeTimer: [], getSecondsUntilUpdate: [], hasChanged: [], getTime: [], getLocale: [] });
/** @nocollapse */
TimeAgoPipe.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: NgZone }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */
/** @type {?} */
const momentConstructor$b = moment;
class UtcPipe {
    /**
     * @param {?} value
     * @return {?}
     */
    transform(value) {
        return momentConstructor$b(value).utc();
    }
}
UtcPipe.ngPipeDef = ɵngcc0.ɵɵdefinePipe({ name: "amUtc", type: UtcPipe, factory: function UtcPipe_Factory(t) { return new (t || UtcPipe)(); }, pure: true });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(UtcPipe, [{
        type: Pipe,
        args: [{ name: 'amUtc' }]
    }], null, { transform: [] });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */
/** @type {?} */
const ANGULAR_MOMENT_PIPES = [
    AddPipe,
    CalendarPipe,
    DateFormatPipe,
    DifferencePipe,
    DurationPipe,
    FromUnixPipe,
    ParsePipe,
    SubtractPipe,
    TimeAgoPipe,
    UtcPipe,
    FromUtcPipe,
    LocalTimePipe,
    LocalePipe,
    ParseZonePipe,
    IsBeforePipe,
    IsAfterPipe
];
class MomentModule {
    /**
     * @param {?=} options
     * @return {?}
     */
    static forRoot(options) {
        return {
            ngModule: MomentModule,
            providers: [
                {
                    provide: NGX_MOMENT_OPTIONS, useValue: Object.assign({}, options)
                }
            ]
        };
    }
}
MomentModule.ngModuleDef = ɵngcc0.ɵɵdefineNgModule({ type: MomentModule });
/*@__PURE__*/ ɵngcc0.ɵɵsetNgModuleScope(MomentModule, { declarations: [AddPipe,
        CalendarPipe,
        DateFormatPipe,
        DifferencePipe,
        DurationPipe,
        FromUnixPipe,
        ParsePipe,
        SubtractPipe,
        TimeAgoPipe,
        UtcPipe,
        FromUtcPipe,
        LocalTimePipe,
        LocalePipe,
        ParseZonePipe,
        IsBeforePipe,
        IsAfterPipe], exports: [AddPipe,
        CalendarPipe,
        DateFormatPipe,
        DifferencePipe,
        DurationPipe,
        FromUnixPipe,
        ParsePipe,
        SubtractPipe,
        TimeAgoPipe,
        UtcPipe,
        FromUtcPipe,
        LocalTimePipe,
        LocalePipe,
        ParseZonePipe,
        IsBeforePipe,
        IsAfterPipe] });
/*@__PURE__*/ ɵngcc0.ɵsetClassMetadata(MomentModule, [{
        type: NgModule,
        args: [{
                declarations: ANGULAR_MOMENT_PIPES,
                exports: ANGULAR_MOMENT_PIPES
            }]
    }], null, null);
MomentModule.ngInjectorDef = ɵngcc0.ɵɵdefineInjector({ factory: function MomentModule_Factory(t) { return new (t || MomentModule)(); } });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

export { AddPipe, CalendarPipe, DateFormatPipe, DifferencePipe, DurationPipe, FromUnixPipe, ParsePipe, MomentModule, SubtractPipe, TimeAgoPipe, UtcPipe, FromUtcPipe, LocalTimePipe, LocalePipe, ParseZonePipe, IsBeforePipe, IsAfterPipe, NGX_MOMENT_OPTIONS };

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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